/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 *
 * Vuelti feliz — success (venta ok, onboarding completo, meta).
 * Port del asset canónico `documentacion/design/brand/logo/vuelti-feliz.svg`
 * a react-native-svg (mismo patrón que SleepingVuelti en ModuleEmptyState).
 * Mantener la moneda orange en el brazo derecho (landmark).
 */
import React from 'react';
import { View } from 'react-native';
import Svg, { Circle, Ellipse, G, Path, Text as SvgText } from 'react-native-svg';

type Props = {
  /** Ancho en px (alto deriva del viewBox 220x242). Default 120. */
  size?: number;
  testID?: string;
};

export function VueltiFeliz({ size = 120, testID }: Props) {
  return (
    <View testID={testID} accessible={false}>
      <Svg width={size} height={(size * 242) / 220} viewBox="0 -12 220 242">
        <G x={100} y={120}>
          <Path d="M55 -55 Q85 -80 95 -105" fill="none" stroke="#0F766E" strokeWidth={7} strokeLinecap="round" />
          <Circle cx={98} cy={-110} r={18} fill="#D97745" stroke="#115E59" strokeWidth={2} />
          <SvgText x={98} y={-104} fontFamily="sans-serif" fontSize={17} fontWeight="700" fill="#FFFFFF" textAnchor="middle">$</SvgText>
          <Ellipse cx={0} cy={0} rx={62} ry={68} fill="#0F766E" />
          <Ellipse cx={-18} cy={-30} rx={22} ry={14} fill="#0D9488" opacity={0.6} />
          <Path d="M-55 -10 Q-75 10 -78 35" fill="none" stroke="#0F766E" strokeWidth={7} strokeLinecap="round" />
          <Circle cx={-80} cy={38} r={9} fill="#0F766E" />
          <Path d="M-20 65 Q-25 80 -22 95" fill="none" stroke="#0F766E" strokeWidth={7} strokeLinecap="round" />
          <Path d="M20 65 Q25 80 22 95" fill="none" stroke="#0F766E" strokeWidth={7} strokeLinecap="round" />
          <Ellipse cx={-22} cy={98} rx={12} ry={6} fill="#115E59" />
          <Ellipse cx={22} cy={98} rx={12} ry={6} fill="#115E59" />
          <Path d="M-30 -18 Q-20 -28 -10 -18" fill="none" stroke="#1C1917" strokeWidth={4} strokeLinecap="round" />
          <Path d="M10 -18 Q20 -28 30 -18" fill="none" stroke="#1C1917" strokeWidth={4} strokeLinecap="round" />
          <Path d="M-25 10 Q0 35 25 10" fill="none" stroke="#1C1917" strokeWidth={4.5} strokeLinecap="round" />
          <Circle cx={-38} cy={5} r={8} fill="#D97745" opacity={0.4} />
          <Circle cx={38} cy={5} r={8} fill="#D97745" opacity={0.4} />
        </G>
      </Svg>
    </View>
  );
}
